import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Layout, About, Jobs, Featured, Footer, Sidebar } from '@components';

const Shell = styled.div`
  position: relative;
  z-index: 1;
  margin: 0 auto;
  min-height: 100vh;
  max-width: 1280px;
  padding: 48px 24px;

  @media (min-width: 768px) {
    padding: 80px 48px;
  }

  @media (min-width: 1024px) {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    padding: 0 96px;
  }
`;

const ContentCol = styled.div`
  padding-top: 96px;

  @media (min-width: 1024px) {
    width: 50%;
    padding: 96px 0;
  }
`;

const IndexPage = ({ location }) => (
  <Layout location={location}>
    <Shell>
      <Sidebar />
      <ContentCol>
        <About />
        <Jobs />
        <Featured />
        <Footer />
      </ContentCol>
    </Shell>
  </Layout>
);

IndexPage.propTypes = {
  location: PropTypes.object.isRequired,
};

export default IndexPage;
